import { CellProcessor } from './cell-processor'

const REGEXP_CELLADDR = /([A-Z]{1,2})(\d+)/;
const REGEXP_ADDREXT = /^(.*[^A-Z])([A-Z]{1,2})(\d+)(.*)$/;
const REGEXP_SUMIFSEXT = /^(.*)(?:SUMIFS\()([^\)]+)\)(.*)$/;
const REGEXP_REGION = /^([A-Z]{1,2})(\d+)(?:\:)([A-Z]{1,2})(\d+)$/;

const IF_EXP = 'const IF = (a,b,c)=> a?b:c;';
const OR_EXP = 'const OR = (...args)=>args.includes(true);';
const VAL_EXP = 'const VALUE = (a)=>isNaN(a)?0:Number(a);';
const AND_EXP = 'const AND = (...args)=>args.every(Boolean);';
const ISNUMBER_EXP = 'const ISNUMBER = (a)=>isNaN(a);';
const ALL_EXP = IF_EXP + OR_EXP + VAL_EXP + AND_EXP + ISNUMBER_EXP;

const EXP_TYPE = {
  EXP: 1,
  CELL: 2,
  REGION: 3,
  FUNCTION: 4
};

const addressToIndex = (addr: string): {row: number, col: number} => {
  const regResult = addr.match(REGEXP_CELLADDR);
  if (regResult === null) return null;
  return rowcolToIndex(regResult[1], regResult[2]);
}

const rowcolToIndex = (col: string, row: string) => {
  let colIndex = 0;
  let colTmp = [];
  const A_CC = 'A'.charCodeAt(0);
  // set row charcode list.
  [].forEach.call(col, (c=>colTmp.unshift(c.charCodeAt(0) - A_CC + 1)));
  // cc list to index.
  for(let colCnt = 0; colCnt<colTmp.length; ++colCnt) {
    colIndex += colTmp[colCnt] * Math.pow(26, colCnt);
  }
  return {
    row: parseInt(row) - 1,
    col: colIndex - 1
  }
}

const getCell = (row:number, col:number, getDataAt:(row:number, col:number) => any, lxrsAll: any[]) => {
  if (!calcedVal[row]) {
    calcedVal[row] = [];
  }
  if (!calcedVal[row][col]) {
    const lxr = lxrsAll.find(l=>l.col == col && l.row == row);
    let val;
    if (lxr) {
      val = calcLexical(lxr.lexical, getDataAt, lxrsAll);
    } else {
      val = getDataAt(row, col);
    }
    if (typeof val === 'string') {
      val = '"' + val + '"';
    } else if (val === null) {
      val = 'null';
    }
    calcedVal[row][col] = val;
  }
  return calcedVal[row][col];
}


const calcLexical = (lxrs: any[], getDataAt: (row: number, col: number) => any, lxrsAll: any[]) => {
  lxrs.forEach(lxr => {
    switch(lxr.type) {
      case EXP_TYPE.EXP:
        lxr.value = lxr.exp;
        break;
      case EXP_TYPE.CELL:
        lxr.value = getCell(lxr.startCell.row, lxr.startCell.col, getDataAt, lxrsAll);
        break;
      case EXP_TYPE.FUNCTION:
        lxr.value = lx_sumifs(lxr.params, getDataAt, lxrsAll);
        break;
    }
  });
  const exp = ALL_EXP + ' return ' + lxrs.reduce((accumulator: string, currentValue: any) => accumulator + currentValue.value, '');
  try {
    return Function(exp)();
  } catch (e) {
    console.error('error exp: ', exp);
    console.log(e);
  }
}

/**
 * lexical analysis.
 */
const lexer = (exp: string) => {
  let epl = [{
    exp: exp,
    type: EXP_TYPE.EXP,
    value: exp,
    startCell: null,
    endCell: null
  }];

  epl[0].exp = ' ' + exp.substring(1).replace(/=/g, '==').replace(/\$/g, '').replace(/<>/g, '!=');

  let eplIndex = 0;
  while(true) {
    // sumifs check
    const regResSi = epl[eplIndex].exp.match(REGEXP_SUMIFSEXT);
    if (regResSi !== null) {
      const sip = [];
      let tmp;
      regResSi[2].split(',').forEach((p: string) => {
        const regResRgn = p.match(REGEXP_REGION);
        if (regResRgn !== null) {
          sip.push({
            exp: p,
            type: EXP_TYPE.REGION,
            startCell: rowcolToIndex(regResRgn[1], regResRgn[2]),
            endCell: rowcolToIndex(regResRgn[3], regResRgn[4])
          });
        } else if((tmp = addressToIndex(p)) !== null) {
          sip.push({
            exp: p,
            type: EXP_TYPE.CELL,
            startCell: tmp
          });
        } else {
          sip.push({
            exp: p,
            type: EXP_TYPE.EXP
          });
        }
      });
      const epl_sumifs = [];
      if (regResSi[1] !== '') {
        epl_sumifs.push({exp: regResSi[1], type: EXP_TYPE.EXP, value: regResSi[1]});
      }
      epl_sumifs.push({exp: 'SUMIFS', type: EXP_TYPE.FUNCTION, params: sip});
      if (regResSi[3] !== '') {
        epl_sumifs.push({exp: regResSi[3], type: EXP_TYPE.EXP, value: regResSi[3]});
      }

      epl = [].concat(epl.slice(0, eplIndex), epl_sumifs, epl.slice(eplIndex + 1));
      continue;
    } // end sumifs

    const regRes = epl[eplIndex].exp.match(REGEXP_ADDREXT);
    if (regRes === null) {
      eplIndex += 2;
      if (eplIndex >= epl.length) break;
      continue;
    }
    const addr = rowcolToIndex(regRes[2], regRes[3]);
    epl = [].concat(epl.slice(0, eplIndex), [
      {exp: regRes[1], type: EXP_TYPE.EXP, value: regRes[1]},
      {exp: regRes[2] + regRes[3], type: EXP_TYPE.CELL, startCell: addr},
      {exp: regRes[4], type: EXP_TYPE.EXP, value: regRes[4]},
    ], epl.slice(eplIndex + 1));
    exp = regRes[1];
  }
  return epl;
}

/**
 * calculate value from the lexical analysis sumifs formula.
 */
const lx_sumifs = (params: any[], getDataAt: (row: number, col: number) => any, lxrsAll: any[]) => {
  // set cond value.
  for (let i = 2; i < params.length; i += 2) {
    params[i].value = params[i].type === EXP_TYPE.CELL ? getCell(params[i].startCell.row, params[i].startCell.col, getDataAt, lxrsAll) : params[i].exp;
  }
  let sumRes = 0;
  // sum data.
  for (let row = params[0].startCell.row; row <= params[0].endCell.row; ++row) {
    for (let col = params[0].startCell.col; col <= params[0].endCell.col; ++col) {
      // cond check.
      let condFlg = true;
      for (let count = 1; count < params.length; count += 2) {
        if (getCell(params[count].startCell.row + row - params[0].startCell.row, params[count].startCell.col + col - params[0].startCell.col, getDataAt, lxrsAll) != params[count+1].value) {
          condFlg = false;
          break;
        }
      }
      if (condFlg) {
        const numCell = Number(getCell(row, col, getDataAt, lxrsAll));
        sumRes += isNaN(numCell) ? 0 : numCell;
      }
    }
  }
  return sumRes;
}

let calcedVal = [];
/**
 * set formula cell to '0' and execute lexical analysis asynchronous.
 */
const preprocessor = (data:any[][], refers:any[][]):Promise<any[]> => {
  calcedVal = []
  const getDataAtFunc = (i, j) => {
    refers[i][j] = true;
    return data[i][j];
  };
  const targetCells = [];
  for (let i = 0, maxRows = data.length; i < maxRows; i++) {
    for (let j = 0, maxCols = data[i].length; j < maxCols; j++) {
      let cell = data[i][j]
      if (typeof cell !== 'string' || !cell.startsWith('=')) continue
      targetCells.push({
        row: i,
        col: j,
        value: cell,
        calcCounter: 0
      });
      data[i][j] = '0';
    }
  }
  return new Promise((resolve, reject)=> {
    const lxr = [];
    targetCells.forEach((c) => {
      c.lexical = lexer(c.value);
      lxr.push(c);
    });
    resolve(lxr);
  });
}

/**
 * calculate value from the lexical analysis result.
 */
const postprocessor = (data:any[][], refers:boolean[][], lxclDatas: any[], instance: any):void => {
  calcedVal = []
  if (!lxclDatas || !lxclDatas[0]) return;
  const begin = {
    col: instance.getInstance().colOffset(),
    row: instance.getInstance().rowOffset()
  };
  const end = {
    col: begin.col + instance.getInstance().countRenderedCols(),
    row: begin.row + instance.getInstance().countRenderedRows()
  }
  const getDataAtFunc = (i:number, j:number) => {
    refers[i][j] = true;
    return data[i][j];
  };
  const calcedVer = lxclDatas[0].calcCounter + 1;
  const calc = (c: any) => {
    data[c.row][c.col] = calcLexical(c.lexical, getDataAtFunc, lxclDatas)
    c.calcCounter = calcedVer;
  }
  const CALC_ROW = 10;
  const calcRows = (cl: any[], row: number, calcedVer: number, isOrderAsc: boolean) => {
    window.setTimeout(() => {
      const notCalced = cl.filter(c=>c.calcCounter !== calcedVer);
      if (cl.length === 0) return;
      if (isOrderAsc) {
        notCalced.filter(c=>row <= c.row && c.row <= row + CALC_ROW).forEach(calc);
        calcRows(notCalced, row + CALC_ROW, calcedVer, isOrderAsc);
      } else {
        notCalced.filter(c=>row - CALC_ROW <= c.row && c.row <= row).forEach(calc);
        calcRows(notCalced, row - CALC_ROW, calcedVer, isOrderAsc);
      }

    }, 1000);
  };

  lxclDatas.filter(c => begin.row <= c.row && c.row <= end.row).forEach(calc);
  calcRows(lxclDatas.filter(c => end.row < c.row), end.row, calcedVer, true);
  calcRows(lxclDatas.filter(c => c.row < begin.row), begin.row, calcedVer, false);
}

export const fast_calc:CellProcessor = {
  preprocess : preprocessor,
  postprocess : postprocessor,
}


// WEBPACK FOOTER //
// ./src/widgets/spread_sheet/spread-sheet/preprocessors/fast_calc.ts